const addressFields = [
  'country',
  'city',
  'neighborhood',
  'state',
  'street',
  'street2',
  'zip',
];

const isAddressEmpty = address =>
  addressFields.every(addressField => (address[addressField] == null || address[addressField] === ''));

// eslint-disable-next-line import/prefer-default-export
export const checkEmptyAddress = (values) => {
  if (!values.address || isAddressEmpty(values.address)) {
    return {
      ...values,
      address: null,
    };
  }
  return values;
};
